/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {BrowserRouter as Router} from "react-router-dom";
import store from "./redux/store";
import {Provider} from "react-redux";
import {StyledEngineProvider} from "@mui/material/styles";
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthenticationResult, EventMessage, EventType, PublicClientApplication} from '@azure/msal-browser';
import {msalConfig} from './auth/authConfig';
import './css/Table-Styling.css'
import {createTheme, ThemeProvider} from '@mui/material/styles';
import CssBaseline from "@mui/material/CssBaseline";
import {MAIN_APP_BACKGROUND_COLOR} from "./constants/colors";

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const msalInstance = new PublicClientApplication(msalConfig);

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}
// console.log("LOGGING PROCESS ENV: ", process.env)
msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});
/*
const ErrorComponent = ({error}: any) => {
  return <p>An Error Occurred: {error}</p>;
}

const LoadingComponent = () => {
  //return <p>Authentication in progress...</p>;
  return <LoadingBar
    color='#8800ff'
    progress={100}
    //height={3}
  />
}*/

const theme = createTheme({
  palette: {
    background: {
      default: MAIN_APP_BACKGROUND_COLOR
    }
  }
});
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
/**
 * NOTE: beware of effects of React.StrictMode (does not affect production build).
 * Your components will re-render an extra time to find bugs caused by impure rendering.
 * Your components will re-run Effects an extra time to find bugs caused by missing Effect cleanup.
 * Your components will be checked for usage of deprecated APIs.
 * See more at: https://react.dev/reference/react/StrictMode
 */
root.render(
  // <React.StrictMode>

  <Provider store={store}>
    <Router>
      {/*<MsalProvider instance={msalInstance}>
            <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
                authenticationRequest={loginRequest}
                errorComponent={ErrorComponent}
                loadingComponent={LoadingComponent}
>*/}
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline/>
          <App pca={msalInstance}/>
        </ThemeProvider>
      </StyledEngineProvider>
      {/*</MsalAuthenticationTemplate>
          </MsalProvider>*/}
    </Router>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
